<div class="page-header">
  <h1 class="page-title">Kunder</h1>
  <mat-divider></mat-divider>
</div>

<div class="table-container">
  <mat-toolbar>
    <a mat-flat-button
       color="accent"
       [routerLink]="['/customers/create']">
      <mat-icon class="mr-2"
                inline="true">add</mat-icon>Skapa
    </a>
  </mat-toolbar>
  <table mat-table
         [dataSource]="dataSource"
         class="table-hover"
         matSort
         matSortActive="id"
         matSortDirection="desc">

    <ng-container matColumnDef="id">
      <th mat-header-cell
          *matHeaderCellDef
          mat-sort-header> ID. </th>
      <td mat-cell
          *matCellDef="let customer"> {{customer.id}} </td>
    </ng-container>

    <ng-container matColumnDef="name">
      <th mat-header-cell
          *matHeaderCellDef
          mat-sort-header> Namn </th>
      <td mat-cell
          *matCellDef="let customer"> {{customer.name}} </td>
    </ng-container>

    <ng-container matColumnDef="organizationId">
      <th mat-header-cell
          *matHeaderCellDef
          mat-sort-header> Organisationsnummer </th>
      <td mat-cell
          *matCellDef="let customer"> {{customer.organizationId}} </td>
    </ng-container>

    <ng-container matColumnDef="type">
      <th mat-header-cell
          *matHeaderCellDef
          mat-sort-header> Kundtyp </th>
      <td mat-cell
          *matCellDef="let customer"> {{CustomerTypeTranslations[customer.type]}} </td>
    </ng-container>

    <ng-container matColumnDef="person">
      <th mat-header-cell
          *matHeaderCellDef
          mat-sort-header> Kontaktperson </th>
      <td mat-cell
          *matCellDef="let customer">
        {{contactPersonLabel(customer)}}
      </td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th mat-header-cell
          *matHeaderCellDef
          class="actions-col"></th>
      <td mat-cell
          *matCellDef="let customer"
          [style.width]="'1px'">
        <button mat-icon-button
                (click)="onDeleteClick($event, customer)"
                class="delete-button"
                aria-label="delete item">
          <mat-icon>delete</mat-icon>
        </button>
      </td>
    </ng-container>

    <tr mat-header-row
        *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row
        *matRowDef="let customer; columns: displayedColumns;"
        [routerLink]="['/customers', customer.id]"></tr>
  </table>
</div>
